import React from 'react';
import { FingotiButton } from './Button';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import PagesIcon from '@material-ui/icons/Pages';

const useStyles = makeStyles(theme => ({

    root: {
        border: '1px solid ' + theme.palette.greyFour.main,
        borderRadius: theme.spacing(1),
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2) + 'px ' + theme.spacing(3) + 'px ',
        borderBottom: '1px solid ' + theme.palette.greyFour.main,
    },
    icon: {
        fontSize: '2.25rem',
        fill: theme.palette.greyOne.main,
    },
    headerText: {
        marginLeft: theme.spacing(2),
    },
    title: {
        color: theme.palette.primary.main,
    },
    pricing: {
        padding: theme.spacing(3),
    },
    price: {
        color: theme.palette.secondary.main,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'space-evenly',
        padding: '0px ' + theme.spacing(2) + 'px',
        paddingBottom: theme.spacing(3)
    },
    button: {
        width: '45%',
    }
}))

export const CustomCard = ({ business, handleContactClick }) => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <PagesIcon className={classes.icon} />
                <div className={classes.headerText}>
                    <Typography variant='h4' className={classes.title}>Custom</Typography>
                    <Typography>{business ? "Business"  : "Personal"} - Custom Tier</Typography>
                </div>
            </div>
            <div className={classes.pricing}>
                <Typography>
                    Please contact us
                </Typography>
            </div>
            <div className={classes.buttons}>
                <FingotiButton
                    light
                    color="secondary"
                    onClick={() => handleContactClick()}
                    className={classes.button}
                >
                    contact
                </FingotiButton>
                <span className={classes.button} />
            </div>
        </div>
    )

}